<app-new-button
  [type]="'secondary'"
  [verticalSize]="'small'"
  [svgIconPath]="'commenting/comment'"
  [isActive]="isPanelOpened$ | async"
  [size]="'responsive'"
>
  {{ 'commenting.commentsBtn' | translate }}
  @if (commentsAndRepliesCount) {
    ({{ commentsAndRepliesCount }})
  }
</app-new-button>
